module.exports = __webpack_public_path__ + "img/熊背乡.786d94bd.png";